import ModalConsumerWrap from './ModalConsumerWrap';
export default ModalConsumerWrap;
